import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes";
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions";

import {
  postFakeForgetPwd,
  postSetNewPwd,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      // const response = yield call(postSetNewPwd, constClass.REST_API_FORGOT_PASSWORD_URL, {
      //   email: user.email,
      // })
      let response;
      if (user.module === "ORGANIZATION") {
        response = yield call(
          postSetNewPwd,
          constClass.REST_API_FORGOT_PASSWORD_URL_ORGANIZATION,
          {
            email: user.email,
            recaptchaToken: user.recaptchaToken,
          },
        );
      } else if (user.module === "Candidate") {
        response = yield call(
          postSetNewPwd,
          constClass.REST_API_FORGOT_PASSWORD_URL_CANDIDATE,
          {
            email: user.email,
          },
        );
      } else if (user.module === "RECRUITER") {
        response = yield call(
          postSetNewPwd,
          constClass.REST_API_FORGOT_PASSWORD_URL_RECRUITER,
          {
            email: user.email,
            recaptchaToken: user.recaptchaToken,
          },
        );
      } else if (
        user.module === "" ||
        user.module === null ||
        user.module === undefined
      ) {
        response = yield call(
          postSetNewPwd,
          constClass.REST_API_FORGOT_PASSWORD_URL_CANDIDATE,
          {
            email: user.email,
          },
        );
      }
      if (response) {
        yield put(userForgetPasswordSuccess("Email sent to your mailbox"));
      }
    } else {
      const response = yield call(postFakeForgetPwd, "/fake-forget-pwd", {
        email: user.email,
      });
      if (response) {
        yield put(userForgetPasswordSuccess("Email sent to your mailbox"));
      }
    }
  } catch (error) {
    yield put(userForgetPasswordError(error));
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)]);
}

export default forgetPasswordSaga;
